import { useCallback, useEffect, useState } from 'react';
import Alert from '../../../../shared/components/Alert/Alert';
import Loader from '../../../../shared/components/Loader/Loader';
import { getAffairHistory } from '../affair.api';
import AffairTimeline from './AffairTimeline';

export default function AffairHistoryPanel({ affair }) {
  const [entries, setEntries] = useState([]); const [loading, setLoading] = useState(true); const [error, setError] = useState('');
  const load = useCallback(async () => { try { setLoading(true); setEntries(await getAffairHistory(affair.id)); setError(''); } catch (e) { setError(e.message); } finally { setLoading(false); } }, [affair.id]);
  useEffect(() => { load(); }, [load]);
  if (loading) return <Loader label="Chargement de l’historique..." />;
  return <section className="affair-panel"><div className="affair-panel__header"><div><h2>Historique non destructif</h2><p>Les activités utilisateur et événements système restent distingués.</p></div><button className="basic-button" type="button" onClick={load}>Actualiser</button></div>{error && <Alert severity="error">{error}</Alert>}<AffairTimeline entries={entries} /></section>;
}
